<!-- 柱状图 -->
<template>
  <div class="h-histogram">
    <h-title :text="'活跃门店走势图'"></h-title>
    <ve-histogram
      :data="chartData"
      :extend="chartExtend"
      width="328px"
      height="220px"
      :settings="chartSettings"
    ></ve-histogram>
    <div class="item">
      <h-title :text="'活跃门店排名'"></h-title>
      <ul class="city-list">
        <transition-group name="list" mode="out-in">
          <li class="city" v-for="item in realList" :key="item.id">
            {{item.name}}
          </li>
          <li class="city" v-if="realList.length >= 1 && realList.length < 2" :key="'one'"></li>
          <li class="city" v-if="realList.length >= 1 && realList.length < 3" :key="'two'"></li>
          <li class="city" v-if="realList.length >= 1 && realList.length < 4" :key="'three'"></li>
          <li class="city" v-if="realList.length >= 1 && realList.length < 5" :key="'four'"></li>
        </transition-group>
      </ul>
    </div>
  </div>
</template>

<script>
import HTitle from '@/components/common/hTitle'
export default {
  data () {
    this.chartSettings = {
      scale: [true, true]
    }
    return {
      chartExtend: {
        legend: {
          show: false
        },
        grid: {
          left: '5%',
          containLabel: true,
          top: '5%',
          bottom: '5%'
        },
        xAxis: {
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 14
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff'
            }
          },
          boundaryGap: ['20%', '20%']
        },
        yAxis: {
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 14
            }
          },
          splitLine: {
            show: false
          },
          position: 'left',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff'
            }
          }
        },
        series: {
          type: 'bar',
          itemStyle: {
            normal: {
              color: 'rgba(68,240,255,1)'
            }
          }
        }
      },
      storeFlag: true,
      realList: [],
      timer3: null
    }
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    storeList: {
      type: Array,
      required: true
    }
  },
  components: {
    HTitle
  },
  watch: {
    storeList (newVal, oldVal) {
      const that = this
      if (newVal.length > 0) {
        clearInterval(that.timer3)
        that.timer3 = null
        if (that.storeList.length > 5) {
          that.realList = that.storeList.slice(0, 5)
          that.timer3 = setInterval(() => {
            if (that.storeFlag) {
              that.realList = that.storeList.slice(5)
              that.storeFlag = false
            } else {
              that.realList = that.storeList.slice(0, 5)
              that.storeFlag = true
            }
          }, 5000)
        } else {
          that.realList = that.storeList
        }
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
.h-histogram
  width 368px
  // box-shadow 0px 0px 20px 0px #3dbdc4
  border-radius 8px
  border 1px solid #3DBDC4
  background #0C1530
  margin-bottom 20px
  .item
    width 328px
    display flex
    flex-direction column
    justify-content flex-start
    align-items flex-start
    margin-bottom 15px
    .city-list
      height 150px
      overflow hidden
      .city
        list-style none
        height 30px
        line-height 30px
        font-size 14px
        color #44F0FF
        margin-left 30px
.list-enter-active, .list-leave-active {
  transition: all .5s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-90px);
}
</style>



// WEBPACK FOOTER //
// src/components/common/hHistogram.vue